// Script names the removed Firebase push integration registered; the path moved between releases.
const LEGACY_PUSH_WORKER_FILES = ['fbm-sw.js', 'service-worker-fb.js'];

// The old code registered this for every visitor, and deleting the script doesn't uninstall it.
export const unregisterLegacyPushWorker = async () => {
  try {
    const registrations = (await navigator.serviceWorker?.getRegistrations()) ?? [];
    const legacy = registrations.filter((registration) => {
      const scriptURL = registration.active?.scriptURL;
      const file = scriptURL && new URL(scriptURL).pathname.split('/').pop();
      return !!file && LEGACY_PUSH_WORKER_FILES.includes(file);
    });
    await Promise.all(legacy.map((registration) => registration.unregister()));
  } catch {
    // Best-effort: a failure only leaves an inert worker behind, so it must never reject.
  }
};
